const selectors = {
	links: '.TextAndAppLinks-app-links .app-link',
};

const writeToClipboardAndRedirect = async link => {
	try {
		await navigator.clipboard.writeText(
			window.location.href.replace(window.location.origin, 'https://secure.fourseasons.com')
		);
	} catch (err) {
		// do nothing
	}
	window.location.href = $(link).data('storelink');
};

export default function textAndAppLinks() {
	$(selectors.links).each((_, link) => {
		link.addEventListener('click', e => {
			e.preventDefault();
			writeToClipboardAndRedirect(link);
		});
	});
}
